import IGeoJSONParser from "../../src/IGeoJSONParser"


export default IGeoJSONParser